import React from 'react';
import { Listbox } from '@headlessui/react';
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid';
import balloonsBg from '../assets/snappyballoons.png';
import weddingBg from '../assets/wedding-engagement.png';

const colors = [
  { id: 1, name: 'Black', value: 'black' },
  { id: 2, name: 'White', value: 'white' },
  { id: 3, name: 'Peach', value: '#FBC4AB' },
  { id: 4, name: 'Balloons', value: 'url(' + balloonsBg + ')' },
  { id: 5, name: 'Wedding/Engagement', value: 'url(' + weddingBg + ')', indicatorColor: '#FFD700' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const BackgroundColorSelector = ({ selectedColor, onChange, disabled }) => {
  const selected = colors.find(color => color.value === selectedColor) || colors[0];

  return (
    <Listbox value={selected} onChange={(color) => onChange(color.value)} disabled={disabled}>
      <div className="relative mt-2">
        <Listbox.Button className={classNames(
          "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary sm:text-sm sm:leading-6",
          disabled && "opacity-50 cursor-not-allowed"
        )}>
          <span className="flex items-center">
            <span
              className="inline-block h-4 w-4 rounded-full border border-gray-300 mr-3"
              style={{ 
                backgroundColor: selected.value.startsWith('url') ? 'transparent' : selected.value,
                backgroundImage: selected.value.startsWith('url') ? selected.value : 'none',
                borderColor: selected.indicatorColor || 'inherit'
              }}
            />
            <span className="block truncate">{selected.name}</span>
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </Listbox.Button>

        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          {colors.map((color) => (
            <Listbox.Option
              key={color.id}
              value={color}
              className={({ active }) =>
                classNames(
                  active ? 'bg-primary text-white' : 'text-gray-900',
                  'relative cursor-default select-none py-2 pl-3 pr-9'
                )
              }
            >
              {({ selected, active }) => (
                <>
                  <div className="flex items-center">
                    <span
                      className="inline-block h-4 w-4 rounded-full border border-gray-300 mr-3"
                      style={{ 
                        backgroundColor: color.value.startsWith('url') ? 'transparent' : color.value,
                        backgroundImage: color.value.startsWith('url') ? color.value : 'none',
                        borderColor: color.indicatorColor || 'inherit'
                      }}
                    />
                    <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                      {color.name}
                    </span>
                  </div>

                  {selected ? (
                    <span
                      className={classNames(
                        active ? 'text-white' : 'text-primary',
                        'absolute inset-y-0 right-0 flex items-center pr-4'
                      )}
                    >
                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                    </span>
                  ) : null}
                </>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
};

export default BackgroundColorSelector; 